import { combineReducers } from "redux"
import customizer from "./customizer/"
import auth from "./auth/"
import navbar from "./navbar/Index"
import dataList from "./data-list/"
import authReducer from "../reducers/authReducer"
import errorReducer from "../reducers/errorReducer"
const rootReducer = combineReducers({
  customizer: customizer,
  auth: auth,
  navbar: navbar,
  dataList:dataList,
  loginAuth: authReducer,
  errors: errorReducer
})

export default rootReducer

